import React, { PropTypes, Component } from 'react';
import Portal from 'components/Portal';

export default class MessagePortal extends Component {
  static displayName = 'MessagePortal';

  render() {
    return (
      <Portal style={{ zIndex: 999, position: 'absolute' }}>
        {this.props.children}
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/MessagePortal.js